import axios from "axios";
import { 
  SET_REPORT_LOADING, SET_NESTED_LOADING,
  GET_REPORT0_FAIL_REAL,CLEAR_STATE_REPORT0_REAL, GET_REPORT0_REAL,
  GET_REPORT0, GET_REPORT_FAIL0, CLEAR_STATE_REPORT0,
  GET_REPORT1, GET_REPORT_FAIL1, CLEAR_STATE_REPORT1, GET_CODE_1, GET_FAIL_CODE1,
  GET_REPORT2, GET_REPORT_FAIL2, CLEAR_STATE_REPORT2,
  GET_REPORT31, GET_REPORT_FAIL31, GET_CODE_31, GET_FAIL_CODE31, CLEAR_CODE31, CLEAR_STATE_REPORT31,
  GET_CODE_32, GET_FAIL_CODE32, CLEAR_CODE32, CLEAR_STATE_REPORT32, GET_REPORT32, GET_REPORT_FAIL32,
  CLEAR_STATE_REPORT4, GET_REPORT_FAIL4, GET_REPORT4,  GET_CODE4, GET_FAIL_CODE4, GET_FAIL_CODE4_NESTED,GET_CODE4_NESTED,
  GET_REPORT5, GET_REPORT_FAIL5, CLEAR_STATE_REPORT5, GET_CODE_5, GET_FAIL_CODE5,
  GET_REPORT6, GET_REPORT_FAIL6, CLEAR_STATE_REPORT6, GET_CODE_6, GET_FAIL_CODE6, GET_CODE_6_NESTED, GET_FAIL_CODE6_NESTED,
  GET_REPORT7, GET_REPORT_FAIL7, CLEAR_STATE_REPORT7,
  GET_REPORT8, GET_REPORT_FAIL8, CLEAR_STATE_REPORT8,
  GET_REPORT82, GET_REPORT_FAIL82, CLEAR_STATE_REPORT82,
  GET_REPORT9, GET_REPORT_FAIL9, CLEAR_STATE_REPORT9,
  GET_REPORT10, GET_REPORT_FAIL10, CLEAR_STATE_REPORT10,
} from '../actions/types'

import { refreshUser } from './authActions'
//pobieranie raportu getReport[numer], pobieranie od kodu do rozwijania getCode[numer]
const token =  localStorage.getItem("token");
const headers =  {
  'Accept': "application/json",
  "Content-Type": "application/json",
  "Authorization":`JWT ${token}`

}
//report 0
export const getReport0 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT0})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/myopk/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT0,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL0,
      });
    }
  }
// nowy raport 0

export const getReportNew0 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT0_REAL})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport0/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT0_REAL,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT0_FAIL_REAL,
      });
    }
  }

//report1
export const getReport1 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT1})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport1/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT1,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL1,
      });
    }
}
export const getCode1 =(params)=>async dispatch => {
  dispatch({ type:  SET_NESTED_LOADING })
  const config = {
      headers:headers,
      method: "get",
      url: `/api/raport1/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE_1,
        payload: response.data,
        code:params['number']
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE1,
      });
    }
}
//report 2
export const getReport2 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT2})
  dispatch({ type: SET_REPORT_LOADING })
  params['ordering'] = 'opk_number'
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport2/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT2,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL2,
      });
    }
}

///report31
export const getReport31 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT31})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport31/`,
      params: params,
    };
    // const config = authTokenConfig
    // config.method = "get",
    // config.url = `/api/raport31/`
    // config.params = params
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT31,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL31,
      });
    }
}

export const getCode31 =(params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  const config = {
      headers:headers,
      method: "get",
      url: `/api/raport31/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE_31,
        payload: response.data,
        code:params['number']
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE31,
      });
    }
}

export const getReport32 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT32})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport32/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT32,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL32,
      });
    }
}

//get code for 32
export const getCode32 =(params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  const config = {
      headers:headers,
      method: "get",
      url: `/api/raport32/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE_32,
        payload: response.data,
        code:params['number']
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE32,
      });
    }
}
//rep 4
export const getReport4 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT4})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport4/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT4,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL4,
      });
    }
}

export const getCode4 =(params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  let urlDict = {
    'dir_cost':'/api/pulpitbezposrednie/', 
    'koszt_dzial_medycz':'/api/raportmedyczne/', 
    'koszt_dzial_niemedycz':'/api/raportniemedyczne/', 
    'procedural_cost':'/api/raportproceduralne/', 
    'manag_cost':'/api/zarzad/'
  }
  let url = urlDict[params.number]?urlDict[params.number]:''
  let number = params['number']
  params['number'] = null
  const config = {
      headers: headers,
      method: "get",
      url: url,
      params: params, 
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE4,
        payload: response.data,
        code: number
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE4,
      });
    }
}

export const getCode4Nested =(active, params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  let urlDict = {
    'dir_cost':'/api/pulpitbezposrednie/', 
    'koszt_dzial_medycz':'/api/raportmedyczne/', 
    'koszt_dzial_niemedycz':'/api/raportniemedyczne/', 
    'procedural_cost':'/api/raportproceduralne/', 
    'manag_cost':'/api/zarzad/'
  }
  let url = urlDict[active]?urlDict[active]:''
  const config = {
      headers: headers,
      method: "get",
      url: url,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE4_NESTED,
        payload: response.data,
        active: active,
        code:params.number.split('-')[0]
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE4_NESTED,
      });
    }
}

export const getReport5 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT5})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport5/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT5,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL5,
      });
    }
}

export const getCode5 =(params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport5/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE_5,
        payload: response.data,
        code:params['number']
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE5,
      });
    }
}

export const getReport6 =(params)=>async dispatch => {
  dispatch({type: CLEAR_STATE_REPORT6})
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport6/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT6,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL6,
      });
    }
}
export const getCode6 =(params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport61/`,
      params: params,
    };
    let category = params['category']
    if(params.category === 'Koszty osobowe (wynagrodzenia z tytułu umowy o pracę, umowy zlecenia, umowy o dzieło, inne umowy cywilno-prawne, świadczenia na rzecz pracowników, podwykonawstwo medyczne)'){
      config.params.category = null
      config.params.subcategory = 'yes'
      config.url = `/api/raport6/`
    }
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE_6,
        payload: response.data,
        category: category
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE6,
      });
    }
}
export const getCode6Nested =(params)=>async dispatch => {
  dispatch({ type: SET_NESTED_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport61/`,
      params: params,
    };
    try {
      let category = params.category
      config.params.category=null
      const response = await axios(config);
      dispatch({
        type: GET_CODE_6_NESTED,
        payload: response.data,
        category: category,
        subcategory:params['subcategory']
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE6_NESTED,
      });
    }
}

export const getReport7 =(params)=>async dispatch => {
  dispatch({ type: CLEAR_STATE_REPORT7 })
  dispatch({ type: SET_REPORT_LOADING })
  let whichapi = ''
  if(['530','535'].includes(params.opk_number.split('-')[0])) whichapi='_2'
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport7${whichapi}/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT7,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL7,
      });
    }
}
export const getReport8 =(params)=>async dispatch => {
  dispatch({ type: CLEAR_STATE_REPORT8 })
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport8/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT8,
        payload: response.data
      });
      dispatch(getReport82(params))
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL8,
      });
    }
}
export const getReport82 =(params)=>async dispatch => {
  dispatch({ type: CLEAR_STATE_REPORT82 })
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport8_2/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT82,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL82,
      });
    }
}
export const getReport9 =(params)=>async dispatch => {
  dispatch({ type: CLEAR_STATE_REPORT9 })
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport9/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT9,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL9,
      });
    }
}
export const getReport10 =(params)=>async dispatch => {
  dispatch({ type: CLEAR_STATE_REPORT10 })
  dispatch({ type: SET_REPORT_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/raport10/`,
      params: params,
    };
    try {
      const response = await axios(config);
      dispatch({
        type: GET_REPORT10,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_REPORT_FAIL10,
      });
    }
}
